var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('div', [_c('v-btn', {
    attrs: {
      "block": "",
      "rounded": "",
      "color": "white"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.modal.open();
      }
    }
  }, [_vm._v("열기")]), _c('modal', {
    ref: "modal"
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }